import { render, staticRenderFns } from "./ProjectABTest.vue?vue&type=template&id=6f8e7858&scoped=true&"
import script from "./ProjectABTest.vue?vue&type=script&lang=js&"
export * from "./ProjectABTest.vue?vue&type=script&lang=js&"
import style0 from "./ProjectABTest.vue?vue&type=style&index=0&lang=less&"
import style1 from "./ProjectABTest.vue?vue&type=style&index=1&id=6f8e7858&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8e7858",
  null
  
)

export default component.exports